const addressFilter = require('./filters/address');
const addressFormDirective = require('./directives/addressFormDirective');
const autoFocusDirective = require('./directives/autoFocusDirective');
const backBtnDirective = require('./directives/backBtnDirective');
const barcodeDirective = require('./directives/barcodeDirective');
const byItemTypeFilter = require('./filters/byItemType');
const byPrintInstanceTicketsFilter = require('./filters/byPrintInstanceTickets');
const CartCalculationResource = require('./resources/CartCalculationResource');
const cartCustomerInfoDirective = require('./directives/cartCustomerInfoDirective');
const cartItemQuantityListenerDirective = require('./directives/cartItemQuantityListenerDirective');
const CategoryResource = require('./resources/CategoryResource');
const charactersFilter = require('./filters/characters');
const contactPhotoDirective = require('./directives/contactPhotoDirective');
const currencySymbolFilter = require('./filters/currencySymbol');
const CustomerAccountsResource = require('./resources/CustomerAccountsResource');
const customTemplateTextDirective = require('./directives/customTemplateTextDirective');
const datepickerParserDirective = require('./directives/datepickerParserDirective');
const DeviceResource = require('./resources/DeviceResource');
const enterDirective = require('./directives/enterDirective');
const ErrorCtrl = require('./controllers/ErrorCtrl');
const fieldInstanceDirective = require('./directives/fieldInstanceDirective');
const fieldOptionPriceDirective = require('@/directives/fieldOptionPriceDirective');
const FieldResource = require('./resources/FieldResource');
const fieldsDirective = require('./directives/fieldsDirective');
const GeneralResponseInterceptor = require('./events/GeneralResponseInterceptor');
const GiftVoucherResource = require('./resources/GiftVoucherResource');
const langFilter = require('./filters/lang');
const LogResource = require('./resources/LogResource');
const MarketingPreferenceResource = require('./resources/MarketingPreferenceResource');
const MembershipPlanResource = require('./resources/MembershipPlanResource');
const MembershipRedemptionResource = require('./resources/MembershipRedemptionResource');
const MembershipResource = require('./resources/MembershipResource');
const MembershipSubscriptionResource = require('./resources/MembershipSubscriptionResource');
const membershipUnredeemableInfoDirective = require('@/directives/membershipUnredeemableInfoDirective');
const memberTileDirective = require('./directives/memberTileDirective');
const momentFilter = require('./filters/moment');
const nameWithTitleDirective = require('./directives/nameWithTitleDirective');
const numPadDirective = require('./directives/numPadDirective');
const OrderResource = require('./resources/OrderResource');
const PartialRefundPaymentResource = require('./resources/PartialRefundPaymentResource');
const PaymentExpressResource = require('./resources/PaymentMethods/PaymentExpressResource');
const PaymentResource = require('./resources/PaymentResource');
const pluralSFilter = require('@/filters/pluralS');
const presentSoldGiftVoucherNameFilter = require('./filters/presentSoldGiftVoucherName');
const presentSoldGiftVoucherRefFilter = require('./filters/presentSoldGiftVoucherRef');
const preventEnterDirective = require('./directives/preventEnterDirective');
const PrivilegesResource = require('./resources/PrivilegesResource');
const ProductAvailabilityResource = require('./resources/ProductAvailabilityResource');
const ProductResource = require('./resources/ProductResource');
const qrCodeDirective = require('./directives/dtQrCodeDirective');
const receiptTaxSummaryDirective = require('./directives/receiptTaxSummaryDirective');
const RedemptionResource = require('./resources/RedemptionResource');
const ReturnReasonResource = require('./resources/ReturnReasonResource');
const SavedAddressResource = require('./resources/SavedAddressResource');
const searchFilterDirective = require('./directives/searchFilterDirective');
const selectOnFocusDirective = require('@/directives/selectOnFocusDirective');
const SessionPriceResource = require('./resources/SessionPriceResource');
const SoldGiftVoucherResource = require('./resources/SoldGiftVoucherResource');
const startFromFilter = require('./filters/startFrom');
const StashedCartResource = require('./resources/StashedCartResource');
const TemplateResource = require('./resources/TemplateResource');
const TicketResource = require('./resources/TicketResource');
const TradingSessionResource = require('./resources/TradingSessionResource');
const transactionRefDirective = require('./directives/transactionRefDirective');
const ucfirstFilter = require('./filters/ucfirst');
const UserResource = require('./resources/UserResource');
const { isObject } = require('@/functions/is');

/**
 * Register global directives.
 * Directives should be prefixed with 'dt' per AngularJS's recommended best practise:
 * https://docs.angularjs.org/guide/directive
 * "In order to avoid collisions with some future standard, it's best to prefix your own directive names. For instance,
 * if you created a <carousel> directive, it would be problematic if HTML7 introduced the same element. A two or three
 * letter prefix (e.g. btfCarousel) works well. Similarly, do not prefix your own directives with ng or they might
 * conflict with directives included in a future version of AngularJS.
 * FIXME: Rename the directives that don't follow this convention, especially the ones that begin with 'ng'.
 *
 * Some of these are better suited to being components instead of directives, but components were not introduced until
 * AngularJS 1.5
 *
 * @param {angular.Module} app
 */
const registerAngularDirectives = (app) => {
    app.directive('dtAddressForm', addressFormDirective);
    app.directive('dtAutoFocus', autoFocusDirective);
    app.directive('dtBackBtn', backBtnDirective);
    app.directive('dtBarcode', barcodeDirective);
    app.directive('dtCartCustomerInfo', cartCustomerInfoDirective);
    app.directive('dtCartItemQuantityListener', cartItemQuantityListenerDirective);
    app.directive('dtContactPhoto', contactPhotoDirective);
    app.directive('dtCustomTemplateText', customTemplateTextDirective);
    app.directive('dtDatepickerParser', datepickerParserDirective);
    app.directive('dtEnter', enterDirective);
    app.directive('dtFieldInstance', fieldInstanceDirective);
    app.directive('dtFieldOptionPrice', fieldOptionPriceDirective);
    app.directive('dtFields', fieldsDirective);
    app.directive('dtMemberTile', memberTileDirective);
    app.directive('dtMembershipUnredeemableInfo', membershipUnredeemableInfoDirective);
    app.directive('dtNameWithTitle', nameWithTitleDirective);
    app.directive('dtNumPad', numPadDirective);
    app.directive('dtPreventEnter', preventEnterDirective);
    app.directive('dtQrCode', qrCodeDirective);
    app.directive('dtReceiptTaxSummary', receiptTaxSummaryDirective);
    app.directive('dtSearchFilter', searchFilterDirective);
    app.directive('dtSelectOnFocus', selectOnFocusDirective);
    app.directive('dtTransactionRef', transactionRefDirective);
};

/**
 * Register global controllers.
 *
 * @param {angular.Module} app
 */
const registerAngularControllers = (app) => {
    app.controller('ErrorCtrl', ErrorCtrl);
};

/**
 * Register global filters.
 * Note: Angular DI does not work on arrow functions, so you must use conventional 'function()'s here.
 * AngularJS supports the arrow notation from 1.5.0 onwards.
 *
 * @see https://github.com/angular/angular.js/commit/44a96a4c140873d9fd8484d870af83a0bb9acabd
 *
 * @param {angular.Module} app
 */
const registerAngularFilters = (app) => {
    app.filter('abs', () => Math.abs);
    app.filter('address', () => addressFilter);
    app.filter('byItemType', () => byItemTypeFilter);
    app.filter('byPrintInstanceTickets', () => byPrintInstanceTicketsFilter);
    app.filter('characters', () => charactersFilter);
    app.filter('currencySymbol', function ($filter, currencyService) {
        return currencySymbolFilter($filter('currency'), currencyService);
    });
    app.filter('encodeURIComponent', () => window.encodeURIComponent);
    app.filter('lang', function (langService) {
        return langFilter(langService);
    });
    app.filter('moment', () => momentFilter);
    app.filter('pluralS', () => pluralSFilter);
    app.filter('soldGiftVoucherRef', () => presentSoldGiftVoucherRefFilter);
    app.filter('soldGiftVoucherName', function ($filter, currencyService) {
        return presentSoldGiftVoucherNameFilter(currencySymbolFilter($filter('currency'), currencyService));
    });
    app.filter('startFrom', () => startFromFilter);
    app.filter('ucfirst', () => ucfirstFilter);
    // Allows us to embed HTML from DigiTickets API directly into our templates
    app.filter('unsafe', function ($sce) {
        return $sce.trustAsHtml;
    });
};

/**
 * Register angular-resource resources.
 *
 * @param {angular.Module} app
 */
const registerAngularResources = (app) => {
    app.factory('cartCalculationResource', CartCalculationResource);
    app.factory('categoryResource', CategoryResource);
    app.factory('customerAccountsResource', CustomerAccountsResource);
    app.factory('deviceResource', DeviceResource);
    app.factory('fieldResource', FieldResource);
    app.factory('giftVoucherResource', GiftVoucherResource);
    app.factory('logResource', LogResource);
    app.factory('marketingPreferenceResource', MarketingPreferenceResource);
    app.factory('membershipPlanResource', MembershipPlanResource);
    app.factory('membershipRedemptionResource', MembershipRedemptionResource);
    app.factory('membershipResource', MembershipResource);
    app.factory('membershipSubscriptionResource', MembershipSubscriptionResource);
    app.factory('orderResource', OrderResource);
    app.factory('partialRefundPaymentResource', PartialRefundPaymentResource);
    app.factory('paymentExpressResource', PaymentExpressResource);
    app.factory('paymentResource', PaymentResource);
    app.factory('privilegesResource', PrivilegesResource);
    app.factory('productAvailabilityResource', ProductAvailabilityResource);
    app.factory('productResource', ProductResource);
    app.factory('redemptionResource', RedemptionResource);
    app.factory('returnReasonResource', ReturnReasonResource);
    app.factory('savedAddressResource', SavedAddressResource);
    app.factory('sessionPriceResource', SessionPriceResource);
    app.factory('soldGiftVoucherResource', SoldGiftVoucherResource);
    app.factory('stashedCartResource', StashedCartResource);
    app.factory('templateResource', TemplateResource);
    app.factory('ticketResource', TicketResource);
    app.factory('tradingSessionResource', TradingSessionResource);
    app.factory('userResource', UserResource);
};

/**
 * @param {angular.Module} app
 * @param {Function} registerRoutes
 */
const configureAngularApp = (app, registerRoutes) => {
    app.config(
        function ($routeProvider, $locationProvider, $sceDelegateProvider, $rootScopeProvider, $httpProvider) {
            // In Webpack registerRoutes is passed in. In Grunt it is defined globally.
            if (typeof registerRoutes === 'function') {
                registerRoutes($routeProvider);
            }

            $sceDelegateProvider.resourceUrlWhitelist(['self']);
            $rootScopeProvider.digestTtl(10);

            // Reset headers to avoid OPTIONS request (aka preflight)
            let formEncodedOptions = { 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8' };
            $httpProvider.defaults.headers = {
                put: formEncodedOptions,
                post: formEncodedOptions,
                patch: formEncodedOptions,
                common: formEncodedOptions,
            };

            // Override $http service's default transformRequest
            $httpProvider.defaults.transformRequest = [
                function (data) {
                    /**
                     * The workhorse; converts an object to x-www-form-urlencoded serialization.
                     *
                     * @param {Object} obj
                     * @returns {String}
                     */
                    let param = function param(obj) {
                        let query = '';
                        let name;
                        let value;
                        let fullSubName;
                        let subValue;
                        let innerObj;
                        let i;
                        const paramsToRemoveFromRequestBody = ['onlineTaskTrigger'];

                        for (name in obj) {
                            if (obj.hasOwnProperty(name)) {
                                value = obj[name];

                                if (paramsToRemoveFromRequestBody.indexOf(name) !== -1) {
                                    // By continuing we do not encode this and remove it from the payload.
                                    continue;
                                }

                                if (value instanceof Array) {
                                    for (i = 0; i < value.length; ++i) {
                                        subValue = value[i];
                                        fullSubName = name + '[' + i + ']';
                                        innerObj = {};
                                        innerObj[fullSubName] = subValue;
                                        query += param(innerObj) + '&';
                                    }
                                } else if (value instanceof Date) {
                                    // Converts all Date objects sent in AJAX request to ISO8601 format.
                                    query += encodeURIComponent(name) + '=' + encodeURIComponent(value.toISOString()) + '&';
                                } else if (value instanceof Object) {
                                    for (let subName in value) {
                                        if (value.hasOwnProperty(subName)) {
                                            subValue = value[subName];
                                            fullSubName = name + '[' + subName + ']';
                                            innerObj = {};
                                            innerObj[fullSubName] = subValue;
                                            query += param(innerObj) + '&';
                                        }
                                    }
                                } else if (value !== undefined && value !== null) {
                                    query += encodeURIComponent(name) + '=' + encodeURIComponent(value) + '&';
                                }
                            }
                        }

                        return query.length ? query.substr(0, query.length - 1) : query;
                    };

                    return isObject(data) && String(data) !== '[object File]' ? param(data) : data;
                },
            ];

            /**
             * @todo The responseInterceptors collection is deprecated in 1.3.0,
             * so refactoring will be required to upgrade.
             */
            // Interceptor for all responses
            $httpProvider.responseInterceptors.push(GeneralResponseInterceptor);
        }
    );
};

module.exports = {
    registerAngularDirectives,
    registerAngularControllers,
    registerAngularFilters,
    registerAngularResources,
    configureAngularApp,
};
